import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "home",
  //   meta: {
  //     navtitle: "首页",
  //   },
  //   component: () => import("../views/home.vue"),
  // },
  {
    path: "/home",
    name: "view",
    meta: {
      navtitle: "首页",
    },
    component: HomeView,
    children: [
      //二级页面
      {
        path: "/menu",
        name: "menu",
        meta: {
          navtitle: "菜单",
        },
        component: () => import("../views/menu.vue"),
        children: [
          //三级页面
          {
            path: "/",
            name: "index",
            meta: {
              navtitle: "工作台",
            },
            component: () => import("../views/threepage/index.vue"),
          },
          {
            path: "/regbtn",
            name: "regbtn",
            meta: {
              navtitle: "信息登记",
            },
            component: () => import("../views/regbtn.vue"),
          },
          {
            path: "/query",
            name: "query",
            meta: {
              navtitle: "信息查询",
            },
            component: () => import("../views/threepage/query.vue"),
          },
          {
            path: "/gradesquery",
            name: "gradesquery",
            meta: {
              navtitle: "中考成绩查询",
            },
            component: () => import("../views/threepage/gradesquery.vue"),
          },
          {
            path: "/high",
            name: "high",
            meta: {
              navtitle: "高中志愿填报",
            },
            component: () => import("../views/threepage/high.vue"),
          },
          {
            path: "/admitquery",
            name: "admitquery",
            meta: {
              navtitle: "高中录取查询",
            },
            component: () => import("../views/threepage/admitquery.vue"),
          },
          {
            path: "/inzhi",
            name: "inzhi",
            meta: {
              navtitle: "中职学校报名",
            },
            component: () => import("../views/threepage/inzhi.vue"),
          },
          {
            path: "/inquery",
            name: "inquery",
            meta: {
              navtitle: "中职录取结果",
            },
            component: () => import("../views/threepage/inquery.vue"),
          },
          {
            path: "/infocheck",
            name: "infocheck",
            meta: {
              navtitle: "信息查询",
            },
            component: () => import("../views/infocheck.vue"),
          },
          {
            path: "/grades",
            name: "grades",
            meta: {
              navtitle: "成绩查询",
            },
            component: () => import("../views/grades.vue"),
          },
          {
            path: "/admission",
            name: "admission",
            meta: {
              navtitle: "录取查询",
            },
            component: () => import("../views/admission.vue"),
          },
          {
            path: "/centerduty",
            name: "centerduty",
            meta: {
              navtitle: "中职报名",
            },
            component: () => import("../views/centerduty.vue"),
          },
        ],
      },
      {
        path: "/reg",
        name: "reg",
        meta: {
          navtitle: "学生信息登记",
        },
        component: () => import("../views/reg.vue"),
      },
      {
        path: "/regconfirm",
        name: "regconfirm",
        meta: {
          navtitle: "学生信息登记确认",
        },
        component: () => import("../views/regconfirm.vue"),
      },
      {
        path: "/notice",
        name: "notice",
        meta: {
          navtitle: "信息登记须知",
        },
        component: () => import("../views/notice.vue"),
      },
      {
        path: "/centerdutyok",
        name: "centerdutyok",
        meta: {
          navtitle: "中职报名确认",
        },
        component: () => import("../views/centerdutyok.vue"),
      },
    ],
  },

  {
    path: "/zhuce",
    name: "zhuce",
    meta: {
      navtitle: "注册",
    },
    component: () => import("../views/login/zhuce"),
  },
  {
    path: "/czpassword",
    name: "czpassword",
    meta: {
      navtitle: "重置密码",
    },
    component: () => import("../views/login/czpassword"),
  },
  {
    path: "/login",
    name: "login",
    meta: {
      navtitle: "登录",
    },
    component: () => import("../views/login/login"),
  },
  {
    path: "/",
    name: "notice",
    component: () => import("../views/notice.vue"),
  },
];

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  routes,
});

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  // 不需要登录就可以访问的路由
  if (
    // 1 == 1 ||
    to.name === "login" ||
    to.name === "czpassword"||
    // to.name === "zhuce" ||
    to.name === "notice"
  ) {
    next();
  } else {
    // console.log(to.name);
    // next();
    const token = sessionStorage.getItem("token");
    if (token == null) {
      next({ name: "notice" });
    } else {
      next();
      // let list = [];
      // if (sessionStorage.getItem("caidan")) {
      //   list = sessionStorage.getItem("caidan");
      // }
      // console.log(to.name);
      // if (to.name === "index") {
      //   next();
      // } else if (
      //   (to.name === "reg" ||
      //     to.name === "regconfirm" ||
      //     to.name === "regbtn") &&
      //   list.indexOf(1) !== -1
      // ) {
      //   next();
      // } else if (to.name === "query" && list.indexOf(2) !== -1) {
      //   next();
      // } else if (to.name === "gradesquery" && list.indexOf(3) !== -1) {
      //   next();
      // } else if (to.name === "high" && list.indexOf(4) !== -1) {
      //   next();
      // } else if (to.name === "admitquery" && list.indexOf(5) !== -1) {
      //   next();
      // } else if (
      //   (to.name === "inzhi" || to.name === "centerdutyok") &&
      //   list.indexOf(6) !== -1
      // ) {
      //   next();
      // } else if (to.name === "inquery" && list.indexOf(7) !== -1) {
      //   next();
      // } else {
      //   next({ name: "login" });
      // }
    }

    // if (token == null) {
    //   next({ name: 'login' })
    // } else {
    //   next()
    // }
  }
});
export default router;
